import React, { useState, useEffect } from "react";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import styles from "../styles/PUFContainer.module.css";
import { ArrowRight, ArrowUpRight, ChevronLeft, ChevronRight, Box, Plus, X } from "lucide-react";
import can1 from '../assets/conatiners/pufContainer/can1.png'
import can2 from '../assets/conatiners/pufContainer/can2.jpg'
import card1 from '../assets/conatiners/pufContainer/card1.jpg';
import card2 from '../assets/conatiners/pufContainer/card2.jpg';
import card3 from '../assets/conatiners/pufContainer/card3.jpg';
import card4 from '../assets/conatiners/pufContainer/card4.jpg';
import faq from '../assets/conatiners/pufContainer/faq.png';
import design from '../assets/conatiners/pufContainer/design1.png';
import design1 from '../assets/conatiners/pufContainer/design2.png';
import { useNavigate } from "react-router-dom";


const cards = [
  {
    title: "40×10×8.5 / 40×8×8.5",
    dark: false,
    list: [
      "Staff Offices Containers",
      "Engineer's Accommodation Containers",
      "Worker Accommodation Containers",
      "Dining Hall Containers",
      "Battery Storage Containers",
      "Gym Hall Containers",
      "Cafe Containers",
      "Store Hall Containers",
      "Cement Store Containers",
      "Tube Well Pump Farm Accommodation Containers",
      "Coffee Shop Containers",
      "Baby Play Area Containers",
      "Toilet Block Containers",
      "Wash Room Block Containers",
      "Class Room Containers",
      "General Residential Containers",
    ],
  },
  {
    title: "20×10×8.5 / 20×8×8.5",
    dark: false,
    list: [
      "Staff Offices Containers",
      "Engineer's Accommodation Containers",
      "Worker Accommodation Containers",
      "Dining Hall Containers",
      "Battery Storage Containers",
      "Gym Hall Containers",
      "Cafe Containers",
      "Store Hall Containers",
      "Cement Store Containers",
      "Tube Well Pump Farm Accommodation Containers",
      "Coffee Shop Containers",
      "Baby Play Area Containers",
      "Toilet Block Containers",
      "Wash Room Block Containers",
      "Class Room Containers",
      "General Residential Containers",
    ],
  },
  {
    title: "10×10×8",
    dark: false,
    list: [
      "Staff Offices Containers",
      "Engineer's Accommodation Containers",
      "Worker Accommodation Containers",
      "Dining Hall Containers",
      "Battery Storage Containers",
      "Gym Hall Containers",
      "Cafe Containers",
      "Store Hall Containers",
      "Cement Store Containers",
      "Tube Well Pump Farm Accommodation Containers",
      "Coffee Shop Containers",
      "Baby Play Area Containers",
      "Toilet Block Containers",
      "Wash Room Block Containers",
      "Class Room Containers",
      "General Residential Containers",
    ],
  },
  {
    title: "6x6x8",
    dark: false,
    list: [
      "Toilet Cabin Containers",
      "Guard Cabin Block Containers",
      "Tube Well Residence  Containers",
      "cement store Containers",
      "Tube well  Pump Farm Store Containers",
      "coffee Shop Containers",
      "Wash Room Block Containers",
      "Cafe Containers  Hall Containers",

    ],
  },
  {
    title: "4x4x8 ",
    dark: false,
    list: [
      "Toilet Cabin Containers",
      "Guard Cabin Block Containers",
      "Farming Store  Containers",
      "Material store Containers",
      "coffee Shop Containers",
      "Wash Room Block Containers",
      "Cafe Containers  Hall Containers",

    ],
  },
];
const PUFContainer = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const navigate = useNavigate()
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 4000);

    return () => clearInterval(timer);
  }, [current]);

  const [cardsPerView, setCardsPerView] = useState(3);

  useEffect(() => {

    const handleResize = () => {

      if (window.innerWidth < 768) {
        setCardsPerView(1);
      } else if (window.innerWidth < 1200) {
        setCardsPerView(2);
      } else {
        setCardsPerView(3);

      }

    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);

  }, []);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % cards.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + cards.length) % cards.length);
  };



  const industryProjects = [
    {
      title: "Engineers’ Accommodation Containers",
      desc: "Comfortable accommodation containers designed for engineers and technical staff. Built for long-term stays with functional and modern interiors.",
      img: card1,
    },
    {
      title: "Project Management Office Containers",
      desc: "Fully equipped office containers for efficient project coordination and planning. Designed to support smooth operations at construction and industrial sites.",
      img: card2,
    },
    {
      title: "Dining Hall & Café Containers",
      desc: "Modern dining and café containers offering a comfortable space for meals. Ideal for project sites, campuses, and commercial facilities.",
      img: card3,
    },
    {
      title: "Gym & Recreation Containers",
      desc: "Modular fitness and recreation containers promoting health and relaxation. Designed for durability, comfort, and everyday employee wellness.",
      img: card4,
    },
  ];


  const faqs = [
    {
      id: 0,
      q: "What are  PUF Containers used for?",
      a: "L&R Prefab Solar India PUF Containers are used for site offices, worker accommodation, storage units, security cabins, and applications requiring insulated spaces.",
    },
    {
      id: 1,
      q: "What sizes are available in  PUF Containers?",
      a: "PUF Containers are available in various standard sizes and can also be manufactured in customized dimensions based on specific project requirements.",
    },
    {
      id: 2,
      q: "Do PUF Containers provide good insulation?",
      a: "Yes. PUF insulated panels provide excellent thermal insulation, helping maintain comfortable indoor temperatures and improving energy efficiency.",
    },
    {
      id: 3,
      q: "Are  PUF Containers suitable for harsh environments?",
      a: "Yes. L&R Prefab Solar India PUF Containers feature durable materials and insulated panels for reliable performance in demanding weather and site conditions.",
    },
    {
      id: 4,
      q: "Can  PUF Containers be customized?",
      a: "Yes. Layouts, doors, windows, electrical fittings, flooring, insulation thickness, HVAC systems, and interior finishes can be customized according to project requirements.",
    },
  ];
  return (
    <div className={styles.wrapper}>
      <Header />

      {/* ── Hero ── */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.topLabel}>L&R Portable Modular Solutions</span>
          <h1 className={styles.mainTitle}>
            PUF Container <br />
            <span>Solutions</span>
          </h1>
          <p className={styles.heroDesc}>Insulated PUF Containers by L&R Prefab Solar India Pvt Ldt offering energy-efficient, durable, and
            flexible modular solutions for offices, accommodation, and industrial site applications.</p>
          <button className={styles.btnWhite} onClick={() => {
            navigate("/contact");
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}>
            <span>Contact Us</span>
            <ArrowRight className={styles.arrow} size={18} />
          </button>
        </div>
      </section>



      {/* ── Intro ── */}
      <section className={styles.intro}>
        <div className={styles.introText}>
          <h2>
            PUF Containers<br />
            <span>Solutions</span>
          </h2>
          <div className={styles.introLine}></div>
        </div>
        <div className={styles.introGrid}>
          <div className={styles.introContent}>
            <p>
              PUF Containers represent a versatile range of portable MS
              modular units designed to meet diverse industrial, commercial, and site
              infrastructure needs. Available in multiple sizes from compact 4×4 units
              to large 40-foot containers, these solutions are engineered for durability,
              mobility, and functional adaptability across applications such as offices,
              accommodation, storage, sanitation, and specialized utility spaces.
            </p>
            <p>
              Built with robust steel structures and customizable layouts, PUF
              containers are ideal for rapid deployment in demanding environments.
              Whether for construction sites, remote project locations, or facilities,
              these modular units offer cost-effective, low-maintenance, and scalable
              solutions that ensure operational efficiency, user comfort, and long-term
              performance.
            </p>
            <button className={styles.btnOutline} onClick={() => {
              navigate("/contact");
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}>
              <span>Get Contact</span>

              <span className={styles.iconWrap}>
                <ArrowUpRight className={styles.icon1} size={18} />
                <ArrowUpRight className={styles.icon2} size={18} />
              </span>
            </button>
          </div>
          <div className={styles.introVisuals}>
            <img src={can1} alt="can" />
          </div>
        </div>
      </section>





      {/* ── Sizes ── */}
      <section className={styles.sizesSec}>
        <div className={styles.sizesInner}>
          <div className={styles.sizesTopRow}>
            <div className={styles.sizesLeft}>
              <h2 >
                The Types of L&R <br />
                <span>Value Granted Sizes</span>
              </h2>
              <div className={styles.secHeadLine}></div>
            </div>
            <p className={styles.sizesDesc}>
              Every Puf Container is offered in multiple core sizes, with
              flexible interior layouts ranging from offices and accommodation to
              dining, sanitary, and storage spaces.
            </p>
          </div>

          <div className={styles.controls}>
            <button onClick={prevSlide}>
              <ChevronLeft size={22} />
            </button>

            <button onClick={nextSlide}>
              <ChevronRight size={22} />
            </button>
          </div>

          <div className={styles.sliderWrapper}>
            <div
              className={styles.sliderTrack}
              style={{
                transform: `translateX(-${current * (100 / cardsPerView)}%)`,
              }}
            >
              {[...cards, ...cards.slice(0, 3)].map((card, index) => (
                <div
                  key={index}
                  className={`${styles.card} ${card.dark ? styles.darkCard : ""
                    }`}
                >
                  <Box
                    size={48}
                    strokeWidth={1.5}
                    className={styles.icon}
                  />

                  <h2>{card.title}</h2>

                  <div className={styles.line}></div>

                  <ul>
                    {card.list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>




      {/* ── Why Choose ── */}
      <section className={styles.whySec}>
        <div className={styles.WhyText}>
          <h2 >
            Why Choose Puf <br />
            <span>MS Containers</span>
          </h2>
          <div className={styles.introLine}></div>
        </div>
        <div className={styles.whyGrid}>
          <div className={styles.whyImgWrapper}>
            <img
              src={can2}
              alt="L&R Value Container"
            />
          </div>

          <div className={styles.whyContent}>
            <p>
              L&R Prefab Solar India Pvt Ldt  PUF MS Containers are engineered with advanced insulated panel technology combined with
              strong MS steel structure, ensuring excellent thermal efficiency, durability, and long service life.
              These containers are specially designed to maintain comfortable internal conditions in extreme hot and
              cold environments, making them highly reliable for industrial,
              commercial, and remote site applications where performance and safety are critical.
            </p>
            <p>
              They offer complete flexibility in design and usage, allowing conversion into site offices, worker
              accommodation, dining halls, classrooms, storage units, washrooms, and other functional spaces. With
              quick installation, easy transportation, and minimal maintenance requirements, L&R PUF MS Containers
              deliver a cost-effective,
              sustainable, and high-performance modular solution for modern infrastructure and project needs.
            </p>
          </div>
        </div>
      </section>




      {/* ── Manufacturing Strength ── */}
      <section className={styles.mfgBand}>
        <div className={styles.scrollWrap}>

        </div>

        <div className={styles.mfgContainer}>
          <div className={styles.mfgText}>
            <h2>
              Our Strength &amp; <br />
              Manufacturing Excellence
            </h2>

            <p>
              At L&R Prefab Solar Inida, we combine advanced engineering, high-quality materials,
              and precision manufacturing processes
              to deliver durable and reliable MS and PUF container solutions
              that meet the highest industry standards.
            </p>

            <div className={styles.LastImage}>
              <img src={design1} alt="png" />
            </div>
          </div>

          <div className={styles.mfgImgWrapper}>
            <img
              src={design}
              alt="Manufacturing"
            />
          </div>
        </div>

      </section>



      {/* ── Products ── */}
      <section className={styles.productsSec}>
        <div className={styles.productsInner}>
          <div className={styles.productsHeader}>
            <div className={styles.productText}>
              <h2>
                L&R Value Granted MS <br />
                <span>Containers Products</span>
              </h2>
              <div className={styles.productsDivider}></div>
            </div>
            <p className={styles.productsSubtext}>
              A range of insulated PUF containers for offices, accommodation, dining, storage,
              and recreation, designed for comfort, efficiency, and quick deployment.
            </p>
          </div>
          <div className={styles.expertiseGrid}>
            {industryProjects.map((item, index) => (
              <div className={styles.expCard} key={index}>
                <img src={item.img} alt={item.title} className={styles.expImg} />

                <div className={styles.expLabel}>
                  <h4>{item.title}</h4>

                  <div className={styles.desc}>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* ── FAQ ── */}
      <section className={styles.faqSec}>
        <span className={styles.introLabel}>• FAQ</span>
        <div className={styles.faqHeader}>
          <div className={styles.faqText}>
            <h2>
              Frequently Asked
              <br />
              <span>Questions</span>
            </h2>
            <div className={styles.FaqsLine}></div>
          </div>
          <p>
            Find quick answers about PUF containers, insulation, applications, durability, and customization.
          </p>
        </div>

        <div className={styles.faqBody}>
          <div className={styles.container}>
            {faqs.map((item, index) => (
              <div
                key={index}
                className={`${styles.faqItem} ${activeIndex === index ? styles.active : ""
                  }`}
              >
                <div
                  className={styles.question}
                  onClick={() => toggleFAQ(index)}
                >
                  <h3>{item.q}</h3>

                  <span className={styles.icon}>
                    {activeIndex === index ? (
                      <X size={28} strokeWidth={2} />
                    ) : (
                      <Plus size={28} strokeWidth={2} />
                    )}
                  </span>
                </div>

                <div
                  className={`${styles.answerWrapper} ${activeIndex === index ? styles.open : ""
                    }`}
                >
                  <div className={styles.answer}>
                    <p>{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.faqImg}>
            <img src={faq} alt="container" />
          </div>
        </div>
      </section>



      {/* ── CTA ── */}
      <section className={styles.cta}>
        <h2>Ready for Your Puf Container Solution?</h2>
        <p>
          Connect with our team to design and deliver compact, durable, and
          fully 20x10  MS Container solutions tailored to your site needs.
        </p>


        <button className={styles.contactBtn} onClick={() => {
          navigate("/contact");
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}>
          <span className={styles.contactText}>Contact Us</span>

          <span className={styles.iconBox} >
            <ArrowRight className={styles.iconOne} size={18} />
            <ArrowRight className={styles.iconTwo} size={18} />
          </span>
        </button>
      </section>

      <Footer />
    </div>
  );
};

export default PUFContainer;